import React from 'react';
import connect from 'react-redux/lib/connect/connect';
import Link from 'react-router-dom/Link';
import { isEmpty } from '../../common/cores';

const AsideInfo = (props) => {
  const { user, unreadNotes, isAuthenticated } = props
    return isAuthenticated && (
          <div className="aside2_box1_wrap">
              <div className="aside2_box1">
                  <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                      <tbody>
                        <tr>
                            <td>
                                <button className="level-icon">LV.{user.level}</button>
                            </td>
                        </tr>
                        <tr>
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> { !isEmpty(props.user) && props.user.loginId }님</td>
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> 보유금액 : <span className="my_font01">{ !isEmpty(user.balance) ? Number(user.balance.money).toLocaleString() : "0"}</span></td>
                        </tr>
                        <tr>
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> 포인트 : <span className="my_font01">{!isEmpty(user.balance) ? Number(user.balance.rolling).toLocaleString() : "0"}</span></td>
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> <a href="/coupon">쿠폰</a></td> 
                        </tr>
                        <tr>        
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> <a href="/messages">쪽지 : <span className="my_font01">({unreadNotes.length})</span></a></td>                
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> <a href="/attendance">출석 </a></td>
                        </tr> 
                        <tr>
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> <a href="/lottery">복권</a></td>                
                            <td><span style={{display:"inline-block", width:"15px"}}><img src="images/dot.jpg" alt=""/></span> <a href="/roulette">룰렛</a></td>
                        </tr>       
                    </tbody>
                  </table>
              </div>
          </div>
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.user.isAuthenticated,
    user: state.user.data,
    page: state.page.pageInfo,
    unreadNotes: state.more.message.unreadNotes
  });
export default connect(mapStateToProps, {})(AsideInfo);


// WEBPACK FOOTER //
// ./src/components/Layout/AsideInfo.js